import script from "./CaskTime.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskTime.vue?vue&type=script&setup=true&lang=js"

import "./CaskTime.vue?vue&type=style&index=0&id=2f2ce156&lang=scss"

const __exports__ = script;

export default __exports__
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSlider,QSeparator});
